import React, { useState } from 'react';
import { Drawer, IconButton, Box } from '@mui/material';
import {
  Field,
  LinkFieldValue,
  SitecoreContext,
  withSitecoreContext,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import MenuIcon from '@mui/icons-material/Menu';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { ICustomContext } from '../../model/ICustomContext';
import CloseIcon from '@mui/icons-material/Close';
import DrillDownMenu from '../DrilldownMenu/DrilldownMenu';
import SubscriptionValidation from '../Subscription/SubscriptionValidation/SubscriptionValidation';
import { SubscriptionRoleFieldsProps } from '../Login/Login';
import StatisticsStoreMenu from '../StatisticsStoreMenu/StatisticsStoreMenu';
import './index.scss';

export type MenuLinkFieldProps = {
  Link: Field<LinkFieldValue>;
  Id?: Field<string>;
  Roles: Array<SubscriptionRoleFieldsProps>;
};

export type MenuFieldsProps = {
  fields: MenuLinkFieldProps;
  displayName: string;
};

export type MobileNavigationProps = WithSitecoreContextProps & {
  fields: {
    data: any;
    items: Array<MenuFieldsProps>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean; custom: ICustomContext };
};

const useStyles = makeStyles((theme: Theme) => ({
  menuButton: {
    marginLeft: theme.spacing(4),
    padding: '0',
  },
  drawer: {
    inset: '91px 0 0 0 !important',
  },
  box: {
    top: '91px',
  },
}));

const MobileNavigation = ({
  fields,
  sitecoreContext,
}: MobileNavigationProps): React.JSX.Element => {
  const classes = useStyles();
  const [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawerState = (open: boolean) => {
    setOpenDrawer(open);
  };

  return (
    <div className="MobileNavigation">
      <Drawer
        disableEnforceFocus={true}
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        hideBackdrop={true}
        className={classes.drawer + ' mobileDrawer'}
      >
        <Box minWidth="100vw" role="presentation" className="mobileDrawerBox">
          <DrillDownMenu
            dataSource={sitecoreContext.custom?.siteHierarchy?.homeNode}
            toggleDrawer={setOpenDrawer}
            drilldownItems={fields.items}
          ></DrillDownMenu>
          <StatisticsStoreMenu isMobile={true} toggleDrawer={toggleDrawerState} />
          <SubscriptionValidation isMobile={true} toggleDrawer={toggleDrawerState} />
        </Box>
      </Drawer>
      <IconButton
        edge="start"
        className={classes.menuButton}
        color="inherit"
        aria-label="open drawer"
        onClick={() => setOpenDrawer(!openDrawer)}
      >
        {openDrawer ? <CloseIcon /> : <MenuIcon />}
      </IconButton>
    </div>
  );
};

export default withSitecoreContext()(MobileNavigation);
